export default {
  tagline: "Популярная карточная игра, онлайн. 🕵️‍♂️",
  "create-game": "Создать игру",
  "new-game": "новая игра",
  "back-to-lobby": "назад в лобби",
  "join-room": "Присоединиться",
  "no-public-room":
    "Сейчас нет общедоступных игр. Создайте и пригласите друзей!",
  "how-to-play": "Как играть",
  "game-tagline":
    "Кодовые имена - игра на угадывание, где команды соревнуются, чтобы найти слова, связанные с подсказкой другого игрока.",
  "see-more": "Ещё...",
  "classic-rules": "Правила: Классика",
  "duet-rules": "Правила: Дуэт",
  "support-authors":
    "Если вам понравилась эта игра, пожалуйста, поддержите авторов и купите бумажную версию!",
  "made-with-love": "Сделано с ♥ в карантине",
  "its-open-source": "Это <1>open-source</1>.",
  "check-our-privacy-policy":
    "Проверьте нашу <2>политику конфиденциальности</2>.",
  "choose-options": "Параметры игры",
  mode: "режим",
  duet: "Дуэт",
  classic: "Классика",
  dictionary: "Словарь",
  "public-game": "Общедоступная игра",
  private: "Приватная",
  public: "Общедоступная",
  "join-game": "Присоединиться",
  "placeholder-join": "присоединитесь в игре, чтобы начать общаться",
  "give-hint": "подсказка",
  "clicked-on": "Выбрал(а)",
  "become-spymaster": "Стать капитаном",
  "switch-teams": "Смена команд",
  "red-adj": "красные",
  "blue-adj": "синие",
  "start-game-classic":
    "Загадывающий команды <1>{{team}}</1> дает подсказку, чтобы начать игру!",
  "see-rules": "Правила",
  "start-game-duet": "Нажмите на карту или дайте подсказку, чтобы начать игру!",
  "copied-to-clipboard": "Скопировано в буфер обмена!",
  "turns-left": "{{ count }} ходов осталось",
  "turns-left_plural": "{{ count }} ходов осталось",
  "game-over": "Игра окончена.",
  "winner-team": "Команда <1>{{team}}</1> побеждает!",
  "black-card-loss": "Вы проиграли, потому что нажали на черную карту.",
  "out-of-time-loss": "У вас вышло время!",
  won: "Вы выйграли!",
  "join-red": "присоединиться к красным",
  "join-blue": "присоединиться к синим",
  "join-side": "присоединиться",
  spectate: "наблюдать",
  "game-started": "в процессе",
  "page-title": "Кодовые имена - Играть онлайн",
  "page-description":
    "Играйте в Кодовые имена онлайн, многопользовательскую игру в слова, доступную на телефоне и на компьютере. В этой игре в ассоциации команды соревнуются, чтобы найти карты, связанные с данной подсказкой.",
  "in-the-room": "В комнате",
  rules: "Правила",
  // todo rules...
  red: "Красные",
  blue: "Синие",
  duetA: "Сторона A",
  duetB: "Сторона B",
  spectator: "Наблюдают",
  "just-joined": "присоединился(ась) к игре!",
  "game-created": "Игра создана.",
  "no-players-yet": "В этой игре пока никого нет!",
  "player-name-placeholder": "имя игрока",
  cards: "слов",
  buymeacoffee: "Поддержите игру, купите мне кофе",
  "positive-reaction-1": "Отлично!",
  "positive-reaction-2": "Хорошая работа!",
  "positive-reaction-3": "Сильный ход.",
  "positive-reaction-4": `Одно очко!`,
  "positive-reaction-5": "Да!",
  "positive-reaction-6": "😎",
  "neutral-reaction-1": "Мимо.",
  "neutral-reaction-2": "Достаточно близко.",
  "neutral-reaction-3": "Повезёт в другой раз.",
  "neutral-reaction-4": "Это был мирный житель.",
  "neutral-reaction-5": `Почти!`,
  "neutral-reaction-6": "Слишком плохо.",
  "black-reaction-1": "Вы только что проиграли!",
  "black-reaction-2": "Другая команда выигрывает!",
  "black-reaction-3": "Ваша команда проигрывает ☠️",
  "black-reaction-4": "О нет, ты выбрал(а) убийцу ☠️",
  "negative-reaction-1": "Упс!",
  "negative-reaction-2": "О нет!",
  "negative-reaction-3": `Другая команда благодарит вас.`,
  "negative-reaction-4": "Не волнуйтесь, вы старались изо всех сил 💛.",
  "negative-reaction-5": "🤦‍♂️",
  "rules-classic-teams": `Игроки делятся на две команды: <1>красные</1> и <3>синие</3>. Один игрок каждой команды выбран в качестве капитана команды 🕵️‍♂️ - остальные рядовые игроки.`,
  "rules-classic-grid": `Двадцать пять карточек со словами случайно выложены в сетке. Часть этих слов представляет <1>синих</1> агентов, часть представляет <3>синих</3> агентов, одно представляет <5>убийцу</5>, а остальные - <7>мирные жители</span>. Капитаны знают цвета каждого слова и по очереди подсказывают своей команде, чтобы они нашли слова своего цвета.`,
  "rules-classic-hints": `Каждая подсказка может состоять только из одного слова и количества карточек, к которым оно относится. Капитан дает подсказку, которая относится к как можно большему количеству слов на картах его / её собственных агентов, но не к каким-либо другим - они могут случайно привести другого игрока к выбору карты, представляющей мирного жителя, вражеского агента или убийцу.`,
  "rules-hint-restrictions": `Подсказка может быть выбрано свободно, если она не является (и не содержит) ни одного из слов на карточках с именами кодов, которые все еще открыты на столе. Фонетические подсказки также запрещены.`,
  "rules-turns":
    "Карточки раскрываются как догадки. Оперативники должны делать хотя бы одно предположение за ход, рискуя ошибочным предположением и его последствиями. Они также могут добровольно завершить свою очередь в любой момент после этого. Они могут угадать до числа, данного капитаном, плюс один (бонус, чтобы найти ранее подсказанное слово).",
  "rules-classic-game-end": `Игра заканчивается, когда идентифицированы все агенты одной команды (🏅), или когда одна команда выбрала <1>убийцу</1> (☠️).`,
  "rules-duet-objective": `Два игрока сотрудничают, чтобы найти 15 слов на доске.`,
  "rules-duet-grid": `Двадцать пять карточек со словами случайно выложены в сетке. Часть этих слов представляют <1>зелёных</1> агентов, часть представляет <3>убийц</3>, а остальные - <5>мирные жители</5>. Каждый игрок знает 9 <7>зелёных</7> слов, некоторые из них пересекаются с другой стороной.`,
  "rules-duet-hints": `Игроки также дают подсказки, чтобы дать возможность другому игроку найти свои зеленые карты. Каждая подсказка может состоять только из одного слова и количества карточек, к которым оно относится. Загадывающий дает подсказку, которая относится к как можно большему количеству слов на картах его / её собственных агентов, но не к каким-либо другим - они могут случайно привести другого игрока к выбору карты, представляющей мирного жителя или убийцу.`,
  "rules-duet-game-end": `Игра заканчивается, когда найдены все 15 зеленых агентов (🏅), или когда любой игрок выбрал <1>убийцу</1> (☠️). Игра ограничена по времени, а именно, у игроков есть в общей сложности 9 ходов, чтобы найти все слова. На выбор <3>мирного жителя</span> тратится один дополнительный ход.`,
  "long-story-short": "Короче говоря",
  "privacy-tldr": `
  <p>Мы храним игры и чаты в нашей базе данных в течение некоторого периода времени, но они могут быть удалены в любой момент. Это единственная информация, которую мы храним.</p>
  <p>Мы используем cookies, чтобы иметь возможность просматривать аналитику об использовании сайта (демография, продолжительность сессий, типы игр). Эта аналитика не содержит личной информации.</p>
  <p>Наш провайдер аналитики Google Analytics.</p>
`,
};
